//layout
export const WINDOW_RESIZE = "WINDOW_RESIZE";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
//auth
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
